module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/etN99L/tc-custom/9781439678695.jpg?1738410659067",
      "alt": "This image is the cover for the book Hoyt-Wallis Murder Mystery in Herkimer County"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hoyt-Wallis Murder Mystery in Herkimer County\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Warren township in the southern portion of Herkimer County has been the scene of more than one gruesome event. "), _c('br'), _vm._v(" In January 1885, locals reeled in horror when disgruntled wife Roxalana Druse shot her husband and dismembered his corpse to incinerate it in a farm house stove. Her trial and hanging was followed up in May of 1901 with two murders in yet another farm house kitchen. John C. Wallis had allowed his ex-wife Arvilla to return home, one year after running off with hired farm hand Ben Hoyt. Wallis then rehired Hoyt and within months both Ben Hoyt and Arvilla Wallis were dead. Did Ben Hoyt murder Arvilla in cold blood or did John C. Wallis kill both of them? "), _c('br'), _vm._v(" Author James M. Greiner investigates a mysterious case of marriage, infidelity and multiple murders in turn of the century Herkimer County.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James M. Greiner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James M. Greiner is the Herkimer County Historian, a retired high school history teacher and the author of several books and articles on local history. He is the president of the Friends of Historic Herkimer County, an organization working to preserve the Historic 1834 Jail, which once held Roxalana Druse, Chester Gillette and John C. Wallis. He resides in Herkimer, New York, with his wife, Teresa, and their two spoiled dogs, Squirt and Bonnie.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0